<template>
  <div>
    <div class="section-labelaudio">
      <div style="float: left">
        <div>
          <audioRender
            :PropsBatchDate="PropsBatchDate"
            :PropsAudioName="PropsAudioName"
            :PropsPlay="PropsPlay"
            style="width: 400px"
          ></audioRender>
        </div>
        <div class="labelaudio__option">
          <div class="option">
            <div class="option__status" style="float:left">
              <input
                type="checkbox"
                style="cursor:pointer;"
                id="cry"
                v-model="cry"
              />
              <label
                for="cry"
                style="cursor:pointer;"
                class="option__status--font"
                >Cry</label
              >
            </div>
            <div class="option__status" style="margin-left:110px">
              <input
                type="checkbox"
                style="cursor:pointer;"
                id="baby_talk"
                v-model="talk"
              />
              <label
                for="baby_talk"
                style="cursor:pointer;"
                class="option__status--font"
                >Talk</label
              >
            </div>
            <div class="option__status">
              <input
                type="checkbox"
                style="cursor:pointer;"
                id="music"
                v-model="music"
              />
              <label
                for="music"
                style="cursor:pointer;"
                class="option__status--font"
                >Music</label
              >
            </div>
            <div class="option__status" style="float:left">
              <input
                type="checkbox"
                style="cursor:pointer;"
                id="adult_talk"
                v-model="cough"
              />
              <label for="adult_talk" class="option__status--font">Cough</label>
            </div>
            <div class="option__status">
              <input
                type="checkbox"
                style="cursor:pointer;"
                id="other"
                v-model="other"
              />
              <label
                for="other"
                style="cursor:pointer;"
                class="option__status--font"
                >Other</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="display:flex;margin-left:60px"></div>
    <div style="display:flex;margin-left:60px">
      <button
        class="btn btn-secondary mg-r-ten btn-fashion"
        @click.prevent="backward()"
        :disabled="current === 1"
      >
        <i class="fas fa-backward"></i>
      </button>
      <button
        class="btn btn-secondary mg-r-ten btn-fashion"
        :disabled="total === current"
        @click.prevent="forward()"
      >
        <i class="fas fa-forward"></i>
      </button>
      <button class="btn btn-primary btn-fashion" @click.prevent="next()">
        Store &amp; Next
      </button>

      <div v-if="is_skip">
        <button
          class="btn btn-primary mg-r-ten btn-fashion"
          @click.prevent="skip()"
          style="margin-left:10px"
        >
          cancelSkip
        </button>
      </div>
      <div v-else>
        <button
          class="btn btn-secondary mg-r-ten btn-fashion"
          @click.prevent="skip()"
          style="margin-left:10px"
        >
          Skip
        </button>
      </div>

      <div style="text-align:right;margin:10px">
        {{ current }} / {{ total }}
      </div>
    </div>
  </div>
</template>

<script>
import client from "@/api/client";
import audioRender from "@/components/audioRender/index.vue";
import audioRender1 from "@/components/audioRender/index_1.vue";

export default {
  components: { audioRender },
  data() {
    return {
      dataGetBackFromChild: [],
      PropsStatus: "cry",
      PropsAudioUrl: null,
      PropsBatchDate: "",
      PropsAudioName: "",
      PropsHasLabeled: [],
      PropsPlay: false,
      batch: {
        batchType: "audio",
        batchDate: "",
        audioName: ""
      },

      // Audio
      cry: 0,
      talk: 0,
      music: 0,
      cough: 0,
      other: 0,

      current: 0, // 當前頁碼
      total: 0, // 總頁碼
      metas: [],
      is_skip: false
    };
  },
  methods: {
    nextLabel() {
      // get next label meta
      const vm = this;
      if (vm.current < vm.total) {
        vm.current += 1;
        client
          .get(`/meta/audio_v2/${vm.metas[vm.current - 1].name}`)
          .then(res => {
            console.log("next get");
            console.log(res);
            vm.PropsAudioName = res.name;
            vm.updateUI(res);
          });
      } else {
        client.get("/meta/audio_v2/to_label").then(res => {
          if (res === 404) {
            this.$bvModal.msgBoxOk("Label completed").then(value => {
              vm.$router.push("/task");
            });
            return;
          }
          console.log(res);
          vm.PropsBatchDate = res.batch_date;
          vm.PropsAudioName = res.name;
          vm.metas.push(res);
          vm.updateUI(res);
          vm.current += 1;
          vm.total += 1;
        });
      }
    },
    next() {
      // put label meta to api
      const vm = this;
      const meta = vm.metas[vm.current - 1];

      meta.labels = [
        vm.cry ? 1 : 0,
        vm.talk ? 1 : 0,
        vm.music ? 1 : 0,
        vm.cough ? 1 : 0,
        vm.other ? 1 : 0
      ];

      console.log("next post");
      console.log(meta);

      client.post("/meta/audio_v2", null, meta).then(res => {
        vm.nextLabel();
      });
    },
    skip() {
      const vm = this;
      const meta = vm.metas[vm.current - 1];
      meta.is_skip = !vm.is_skip;

      console.log("skip post");
      console.log(meta);
      client.post("/meta/audio_v2", null, meta).then(res => {
        vm.nextLabel();
      });
    },
    backward() {
      // 倒退
      const vm = this;
      vm.PropsHasLabeled = [];
      if (vm.current !== 1) {
        vm.current -= 1;
        client
          .get(`/meta/audio_v2/${vm.metas[vm.current - 1].name}`)
          .then(res => {
            console.log("get");
            console.log(res);
            vm.updateUI(res);
            vm.PropsAudioName = res.name;
          });
      }
    },
    forward() {
      // 前進
      const vm = this;
      vm.current += 1;
      client
        .get(`/meta/audio_v2/${vm.metas[vm.current - 1].name}`)
        .then(res => {
          console.log("prev get");
          console.log(res);
          vm.updateUI(res);
          vm.PropsAudioName = res.name;
        });
    },
    updateUI(res) {
      const vm = this;
      vm.is_skip = res.is_skip;

      // audio 1
      const label = res.labels;
      vm.cry = label[0] === 1;
      vm.talk = label[1] === 1;
      vm.music = label[2] === 1;
      vm.cough = label[3] === 1;
      vm.other = label[4] === 1;
    }
  },
  mounted() {
    const vm = this;
    vm.nextLabel();
    // eslint-disable-next-line
    document.onkeydown = function(e) {
      const keycode = {
        Escape: () => {
          vm.hidebox();
        },
        Enter: () => {
          vm.next();
          e.preventDefault();
        },
        ArrowLeft: () => {
          if (vm.current !== 1) {
            vm.backward();
          }
        },
        ArrowRight: () => {
          if (vm.total !== vm.current) {
            vm.forward();
          }
        },
        Space: () => {
          if (vm.PropsPlay) {
            vm.PropsPlay = false;
          } else {
            vm.PropsPlay = true;
          }
          e.preventDefault();
        }
      };
      keycode[e.code]();
    };
  }
};
</script>
